<div class="avatar" [class.empty-avatar]="!bet">
  @if (bet) {
  <img
    class="avatar-image"
    [src]="bet?.avatar"
    [toggleUserAction]="bet.steamid !== '-1' ? bet : null"
    width="72"
    height="72"
    [class.filter-grayscale]="bet?.reveal || (coinflip.status === 'joining' && !coinflip.bot_called && bet.steamid !== coinflip.host.steamid)"
  />
  <app-coinflip-coin [side]="bet" [size]="uiService.screenSize === 'XSmall' ? 22 : 28" [anim]="false" class="coinflip-coin"></app-coinflip-coin>
  } @else { ?
  <app-coinflip-coin
    [side]="coinflip?.host?.side === blueSide ? 'orange' : 'blue'"
    [size]="uiService.screenSize === 'XSmall' ? 22 : 28"
    [anim]="false"
    class="coinflip-coin"
  ></app-coinflip-coin>
  }
</div>
<!--  -->
<div class="top-wrapper">
  <div
    class="top"
    [ngClass]="{
    'blue-blur': bet && bet?.side === blueSide && (!coinflip.revealed || showAnimation),
    'red-blur': bet && bet?.side === redSide && (!coinflip.revealed || showAnimation),
    'green-blur': (coinflip?.winner?.side === bet?.side && coinflip?.revealed) && !showAnimation,
}"
  >
    @if (bet) {
    <div class="user" [class.filter-grayscale]="bet?.reveal || (coinflip.status === 'joining' && !coinflip.bot_called && bet.steamid !== coinflip.host.steamid)">
      <div class="name" [toggleUserAction]="bet.steamid !== '-1' ? bet : null">
        {{ bet?.name | name }}
      </div>
      <app-level-new class="user-level user-level badge badge_rounded badge_font-l" [level]="bet.level"></app-level-new>
    </div>
    <div
      class="value"
      [ngClass]="{
        won: coinflip?.winner && coinflip?.winner?.side === bet.side && coinflip?.revealed && !showAnimation,
        lose: coinflip?.winner && coinflip?.winner?.side !== bet.side && coinflip?.revealed && !showAnimation
      }"
    >
      <app-icon icon="coin" [width]="16"></app-icon>
      <app-currency
        [value]="
          coinflip?.winner && coinflip?.winner?.side === bet?.side && coinflip.revealed && !showAnimation
            ? coinflip.host.value + coinflip.part.value
            : coinflip.winner && coinflip.winner.side !== bet.side && coinflip?.revealed && !showAnimation
            ? coinflip.host.value - coinflip.host.value * 2
            : coinflip.host.value ?? 0
        "
        [animation]="true"
        [symbol]="coinflip?.winner && coinflip?.winner?.side === bet?.side && coinflip.revealed && !showAnimation ? '+' : false"
      ></app-currency>
    </div>
    <div class="badge badge_black chance-badge">{{ bet?.chance ?? 0 | number : '1.2-2' }}%</div>
    } @else {
    <div class="actions">
      @if (coinflip?.host?.steamid === session?.profile()?.steamid) {
      <button class="button font-default-bold green medium-2" (click)="callBot()">Call Bot</button>
      <button
        class="button font-default-bold black medium-2"
        [disabled]="coinflip?.host?.steamid !== session?.profile()?.steamid || coinflip.status !== 'open'"
        (click)="shareBattle()"
      >
        <app-icon [icon]="'cfShare'" [width]="16"></app-icon>
      </button>
      } @else {
      <button class="button font-default-bold green medium-2" (click)="join()">Join Coinflip</button>
      }
    </div>
    }
  </div>
</div>

<div
  [class.skins-shadow]="(bet?.skins ?? []).length > 0"
  [class.filter-grayscale]="bet?.reveal || (coinflip.status === 'joining' && !coinflip.bot_called && bet?.steamid !== coinflip.host.steamid)"
>
  <div class="bottom" [class.empty-skins]="bet?.skins?.length === 0 || !bet?.skins">
    @if (bet?.skins) {
    <app-item-list class="items" [items]="bet?.skins ?? []"></app-item-list>
    } @else {
    <!--  -->
    <div class="info">
      <p class="dots">Waiting for player</p>
      <div class="badge badge_black min-max">{{ coinflip.min_val | currency : 'USD' : '＄' : '1.2-2' }} - {{ coinflip.max_val | currency : 'USD' : '＄' : '1.2-2' }}</div>
    </div>
    <!--  -->
    }
  </div>
</div>
